<template>
  <div>
    <div class="dropdown">
      <b-spinner v-if="toggleLoadingActionsV2" variant="success" label="Spinning"></b-spinner>
      <i v-else class="fa fa-ellipsis-v btn-edit" @click="funCclickShowHide()"></i>
      <div class="dropdown-child" style="line-height: 0.8" v-show="clickShowHide">
        <span v-if="iTabs == 1 || iTabs == 7">
          <header id="_bv_dropdown-group-1_group_dd_header" class="dropdown-header">
            Produtos
          </header>
          <a id="id-do-elemento" href="#" @click="listagemDeConferencia()">
            Gerar lista de separação
          </a>
        </span>
        <hr v-if="iTabs == 1" role="separator" aria-orientation="horizontal" class="dropdown-divider" />
        <span>
          <header id="_bv_dropdown-group-1_group_dd_header" class="dropdown-header">
            {{ iTabs == 4 || iTabs == 5 ? "Notificações" : "Status do pedido" }}
          </header>
          <a v-if="iTabs == 0" id="id-do-elemento" href="#" @click="
            trocaStatus(
              expeditionsTabs[1].filters.status,
              expeditionsTabs[1].filters.sub_status,
              'Pendente de separação'
            )
            ">
            Mover para pendente de separação
          </a>
          <a v-if="iTabs == 1" id="id-do-elemento" href="#" @click="
            trocaStatus(
              expeditionsTabs[2].filters.status,
              expeditionsTabs[2].filters.sub_status,
              'Em separação'
            )
            ">
            Mover para em separação
          </a>
          <a v-if="iTabs == 2" id="id-do-elemento" href="#" @click="
            trocaStatus(
              expeditionsTabs[3].filters.status,
              expeditionsTabs[3].filters.sub_status,
              'Separados'
            )
            ">
            Mover para separados
          </a>
          <a v-if="iTabs == 3" id="id-do-elemento" href="#" @click="
            trocaStatus(
              expeditionsTabs[4].filters.status,
              expeditionsTabs[4].filters.sub_status,
              'Aguardando NF-e'
            )
            ">
            Mover para aguardando NF-e
          </a>

          <a v-if="iTabs == 4 || iTabs == 5" id="id-do-elemento" href="#" @click="resendNotifications()">
            Reenviar
          </a>
          <a v-if="iTabs == 6" id="id-do-elemento" href="#" @click="
            trocaStatus(
              expeditionsTabs[7].filters.status,
              expeditionsTabs[7].filters.sub_status,
              'Pronto para embalar')">
            Mover para pronto para embalar
          </a>
          <a v-if="iTabs == 7" id="id-do-elemento" href="#" @click="
            trocaStatus(
              expeditionsTabs[8].filters.status,
              expeditionsTabs[8].filters.sub_status,
              'Aguardando retirada')
            ">
            Mover para aguardando retirada
          </a>
          <a v-if="expedition === 'em_transito'" id="id-do-elemento" href="#" @click="
            trocaStatus(
              expeditionsTabs[9].filters.status,
              expeditionsTabs[9].filters.sub_status,
              'Entregue'
            )
            ">
            Mover para entregue
          </a>
        </span>
        <hr role="separator" aria-orientation="horizontal" class="dropdown-divider" />
        <span v-if="expedition === 'pronto_para_embalar'">
          <header id="_bv_dropdown-group-1_group_dd_header" class="dropdown-header">
            Impressões
          </header>
          <a id="id-do-elemento" href="#" @click="imprimirEtiqueta()">
            Imprimir etiquetas selecionadas
          </a>
          <a id="id-do-elemento" href="#" @click="imprimirEtiquetaDanfeSimplificada()">
            Imprimir etiqueta e DANFE simplificada selecionadas
          </a>
        </span>
        <span v-if="expedition === 'etiqueta' || expedition === 'pronto_para_embalar'
          ">
          <header id="_bv_dropdown-group-1_group_dd_header" class="dropdown-header">
            Documentos
          </header>
          <a id="id-do-elemento" href="#" @click="gerarEtiqueta()">
            Gerar etiquetas selecionadas
          </a>
          <a id="id-do-elemento" href="#" @click="plpcreate('action_create_plp')">
            Gerar PLP
          </a>
        </span>
        <hr v-if="expedition === 'pronto_para_embalar'" role="separator" aria-orientation="horizontal"
          class="dropdown-divider" />
        <span v-if="expedition === 'etiqueta' || expedition === 'pronto_para_embalar'
          " header="Últimas plps geradas">
          <PLPsDownload />
        </span>
      </div>
    </div>
    <Action :items="items" :value="value" :loadTotalOrders="loadTotalOrders" :filters="filters" :filtro="filtro"
      :checked="checked" :user="usr_orders" :listen_bus="listen_bus" :expedition="expedition" />
  </div>
</template>

<script>
import PLPsDownload from "../../../Orders_v2/Aggregates/ActionMenuDropdown/PLPsDownload.vue";
import DanfeA4Simplified from "../../../../util/danfeA4Simplified";
import Action from "../../../Orders_v2/Aggregates/Action.vue";
import barramento from "../../../../barramento";
import swal from "sweetalert2";
import axios from "axios";

export default {
  name: "ActionMenuDropdown",
  components: { PLPsDownload, Action },
  props: [
    "items",
    "usr_orders",
    "filters",
    "expedition",
    "checked",
    "iTabs",
    "expeditionsTabs",
  ],
  data() {
    return {
      filtro: null,
      value: null,
      listen_bus: "edit_option_status_entregue_",
      clickShowHide: false,
      loadTotalOrders: null,
      toggleLoadingActionsV2: false,
    };
  },
  methods: {
    plpcreate(status) {
      barramento.$emit(
        "edit_option_status_entregue_" + this.expedition,
        status
      );
      this.funCclickShowHide();
    },
    funCclickShowHide() {
      this.clickShowHide = !this.clickShowHide;
    },
    imprimirEtiqueta() {
      var order = [];
      if (this.checked.length > 0) {
        for (var i in this.items) {
          if (this.checked.includes(this.items[i].id))
            order.push(this.items[i]);
        }
      } else order = this.items;

      DanfeA4Simplified.forEtiqueta(order, this.expedition);
    },
    imprimirEtiquetaDanfeSimplificada() {
      this.toggleLoadingActionsV2 = true;
      var itemsArray = [];
      for (var i = 0; i < this.checked.length; i++) {
        for (var j = 0; j < this.items.length; j++) {
          if (this.items[j].id === this.checked[i]) {
            itemsArray.push(this.items[j]);
          }
        }
      }

      DanfeA4Simplified.printDanfA4Simplificada(
        itemsArray,
        true,
        this.expedition
      );
    },
    gerarEtiqueta() {

      this.funCclickShowHide();

      if (!this.checked.length) {
        swal({
          title: "Ops!",
          text: this.$t(
            "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido para realizar esta ação."
          ),
          type: "warning",
        });
        return false;
      }

      var oders_id = []; // FILTRAR O QUE NÃO É Fulfillment
      for (var i in this.items) {
        if (
          this.items[i].delivery_type !== "fulfillment" &&
          this.checked.find((fruit) => fruit === this.items[i].id)
        ) {
          oders_id.push(this.items[i].id);
        }
      }

      if (!oders_id.length) {
        swal({
          title: "Ops!",
          text: this.$t(
            "Todos pedidos selecionados são Fulfillment, etiquetas não disponibilizadas."
          ),
          type: "warning",
        });
        return false;
      }

      this.toggleLoadingActionsV2 = true;
      axios({
        method: "POST",
        url: "/api/documents/make_label",
        data: oders_id,
        headers: { "content-type": "application/json" },
      }).then(
        (response) => {
          var urls = response.data.urls;
          for (var i in urls) {
            var pdf_link = urls[i];
            if (!!pdf_link) {
              var type = pdf_link.substr(pdf_link.length - 3);
              let link = document.createElement("a");
              link.setAttribute("href", pdf_link);
              link.setAttribute("target", "_blank");
              if (type == "zpl") {
                link.setAttribute("download", "etiqueta.zpl");
                link.href = window.URL.createObjectURL(
                  new Blob([pdf_link], { type })
                );
              } else {
                link.setAttribute("download", pdf_link);
              }
              link.style.display = "none";
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(link.href);
              document.body.removeChild(link);

              barramento.$emit(`expedition_loding_${this.expedition}`);
            }
          }
          this.toggleLoadingActionsV2 = false;
        },
        (error) => {
          this.toggleLoadingActionsV2 = false;
          let message = "Etiqueta não está disponivel";
          if (
            error.response &&
            (typeof error.response.data === "string" ||
              error.response.data instanceof String)
          ) {
            message = error.response.data;
          }
          swal({
            title: "Ops!",
            html: message,
            type: "warning",
          });
        }
      );
    },
    trocaStatus(status = null, sub_status = null, label = null) {
    if (label === 'Pronto para embalar') {
      swal({
        title: this.$t("Confirmação Necessária"),
        text: this.$t("Existem pedidos sem etiqueta que serão movidos para 'Pronto para embalar'. Deseja continuar?"),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Sim"),
        cancelButtonText: this.$t("Não"),
      }).then((ok) => {
        if (ok.value === true) {
          this.executeStatusChange(status, sub_status, label, true);
        }
      });
    } else {
      swal({
        title: this.$t("Você tem certeza?"),
        type: "warning",
        text: this.$t(`Os pedidos selecionados irão para status ${label}, deseja continuar?`),
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: true,
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((ok) => {
        if (ok.value === true) {
          this.executeStatusChange(status, sub_status, label, false);
        }
      });
    }
  },

  executeStatusChange(status, sub_status, label, setHasLabel) {
    this.funCclickShowHide();
    this.toggleLoadingActionsV2 = true;
    barramento.$emit(`expedition_splice_${this.expedition}`, {
      status: "warning",
      ids: this.checked,
    });

    let obj = this.checked.map((id) => {
      let orderData = {
        id: id,
        status: status,
        sub_status: sub_status,
      };
      if (setHasLabel) {
        orderData.tags = { has_label: 1 }; 
      }
      return orderData;
    });

    this.$http
      .post("/api/orders/updatestatus", obj)
      .then((response) => {
        this.toggleLoadingActionsV2 = false;
        barramento.$emit(`expedition_splice_${this.expedition}`, {
          status: "success",
          ids: this.checked,
        });
        setTimeout(() => {
          barramento.$emit(`expedition_splice_${this.expedition}`, {
            status: "splice",
            ids: this.checked,
          });
        }, 2000);
      })
      .catch((error) => {
        this.toggleLoadingActionsV2 = false;
        let errors = '';
          for (const [key, value] of Object.entries(error.response.data)) {
              errors += `<li><strong>${key}:</strong> ${value}</li>`;
          }
          swal({
            title: "Ops!",
            type: "warning",
            html: `<ul>${errors}</ul>`,
          });
      });
  },

    listagemDeConferencia() {
      var produtos = [];
      this.funCclickShowHide();
      for (const ii in this.items) {
        if (this.checked.indexOf(this.items[ii].id) >= 0) {
          produtos.push(this.items[ii]);
        }
      }
      barramento.$emit("expedition_lista_de_sepacao", produtos);
    },
    resendNotifications() {
      this.toggleLoadingActionsV2 = true;
      this.clickShowHide = false;
      if (!this.checked.length) {
        swal({
          title: "Ops!",
          type: "warning",
          text: this.$t("Você selecionou os pedidos para aplicar esta ação?"),
        });
        this.toggleLoadingActionsV2 = false;
        return;
      }

      this.$http
        .post("/api/orders/notification/resend", this.checked)
        .then((response) => {
          this.toggleLoadingActionsV2 = false;
          if (response.data) {
            let ids = response.data.join(", ");
            if (ids.length != 0) {
              swal({
                title: "Ops!",
                type: "warning",
                text: this.$t(
                  "Não foi possivel reenviar as notificações dos pedidos selecionados, tente novamente em alguns instantes."
                ),
              });
              return;
            }
            swal({
              title: "Sucesso",
              type: "success",
              text: this.$t(
                "O reenvio das notificações foi realizado com sucesso!"
              ),
            });
          }
        })
        .catch((error) => {
          this.toggleLoadingActionsV2 = false;
          swal(
            "Ops!",
            this.$t(
              "Não foi possivel reenviar a notificação para os pedidos selecionados, tente novamente em alguns instantes."
            ),
            "warning"
          );
        });
    },
  },
  beforeMount() {
    this.listen_bus = this.listen_bus + this.expedition;
  },
  beforeDestroy() {
    barramento.$off("action_props_totos");
    barramento.$off(`expedition_menu_dropdown_spinner_${this.expedition}`);
    barramento.$off(`expedition_click_show_hide_${this.expedition}`);
  },
  created() {
    barramento.$on("action_props_totos", (objeto) => {
      this.value = objeto.value;
      this.loadTotalOrders = objeto.loadTotalOrders;
    });
    barramento.$on(
      `expedition_menu_dropdown_spinner_${this.expedition}`,
      (status) => {
        this.toggleLoadingActionsV2 = status;
      }
    );
    barramento.$on(
      `expedition_click_show_hide_${this.expedition}`,
      (status) => {
        this.clickShowHide = status;
      }
    );
  },
};
</script>

<style scoped>
.mainmenubtn {
  color: black;
  border: none;
  cursor: pointer;
}

.mainmenubtn:hover {
  background-color: #f8f9fa;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-child {
  background-color: #f8f9fa;
  min-width: 500px;
  position: absolute;
  left: 20px;
  top: 0px;
  z-index: 100;
  margin-top: 20px;
  border: none;
  padding: 8px;
  margin-top: 8px;
}

.dropdown-child a {
  color: black;
  padding: 8px;
  text-decoration: none;
  display: block;
  cursor: pointer;
}

.dropdown:hover .dropdown-child {
  display: block;
}

#id-do-elemento:hover {
  background-color: #e0e0e0;
  transition: 0.5s;
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Expeditions_v2/Aggregates/ActionMenu/ActionMenuDropdown.vue